module.exports = __webpack_public_path__ + "static/img/telegram.3331944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/telegram.svg
// module id = v6vM
// module chunks = 0